<template>
  <div>
    <v-container fluid grid-list-xl>
      <v-layout wrap>
        <v-flex md2 xs4>
          <v-switch
            v-model="tournament.active"
            :disabled="!Edit"
            :label="$t('active')"
            color="primary"
          ></v-switch>
        </v-flex>
        <v-flex md2 sm4 xs8>
          <v-switch
            v-model="tournament.showRanking"
            :disabled="!Edit"
            :label="$t('showRanking')"
            color="primary"
          ></v-switch>
        </v-flex>
        <v-flex md2 sm4 xs12>
          <v-switch
            v-model="tournament.openInscription"
            :disabled="!Edit"
            :label="$t('openInscription')"
            color="primary"
          ></v-switch>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <v-text-field :disabled="true" prepend-icon="attach_file" v-model="titleFile">
            <template slot="label">{{$t('image')}}</template>
          </v-text-field>
          <upload-button :fileChangedCallback="fileChanged" :title="titleButton" :disabled="!Edit" />
        </v-flex>
        <v-flex md3 sm6 xs12 v-if="tournament.image">
          <v-img :src="tournament.image" width="100%" />
          <!-- <clipper-preview class="basic md" name="preview"></clipper-preview> -->
        </v-flex>
        <!-- <v-flex md4 sm6 xs12 v-if="tournament.image && Edit">
            <div style="max-width: 200px">
              <clipper-basic :src="tournament.image" class="basic lg" preview="preview"></clipper-basic>
            </div>
        </v-flex>-->
      </v-layout>
      <v-layout wrap>
        <v-flex d-flex lg12 md12 sm12 xs12>
          <v-tabs color="primary" fixed-tabs ref="tablanguage">
            <v-tab
              :key="index + 100"
              v-for="(lang, index) in tournament.name"
            >{{lang.language.name}}</v-tab>
            <v-tab-item :key="index + 200" v-for="(lang, index) in tournament.name">
              <v-container fluid grid-list-xl>
                <v-layout wrap>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <IgTextField
                      :disabled="!Edit"
                      :rules="valid ? [] : [v => !lang.language.required || rules.vacio(v, 'name')]"
                      :status="true"
                      :label="$t('name')"
                      v-model="lang.text"
                    ></IgTextField>
                  </v-flex>
                  <v-flex d-flex lg12 md12 sm12 xs12>
                    <IgTextField
                      :disabled="!Edit"
                      :status="true"
                      :label="$t('description')"
                      v-model="tournament.description[index].text"
                    ></IgTextField>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex d-flex lg3 md6 sm6 xs12>
          <v-select
            deletable-chips
            chips
            multiple
            :rules="valid ? [] : [rules.length0]"
            :items="listStadiums"
            :label="$t('select', {field:$tc('stadium',2)})"
            :error-count="aulas.length > 0 ? aulas.length : 1"
            :error-messages="aulas"
            v-model="tournament.stadiumId"
            @change="searchStadium = ''"
            :search-input.sync="searchStadium"
          ></v-select>
        </v-flex>
        <v-flex d-flex lg3 sm6 xs12>
          <v-select
            :clearable="true"
            :chips="true"
            :rules="valid ? [] : [v => rules.vacio(v, 'act')]"
            :items="acts"
            :label="$t('select', {field:$tc('act')})"
            v-model="tournament.act"
          ></v-select>
        </v-flex>
        <v-flex d-flex lg3 sm6 xs12>
          <v-text-field
            type="number"
            name="input-1"
            :label="$t('numberParticipants', { field : nameParticipants })"
            id="test"
            min="1"
            max="100"
            step="1"
            maxlength="3"
            :rules="valid ? [] : [v => rules.vacio(v, 'participants'), rules.nteams]"
            v-model="tournament.numberParticipants"
          ></v-text-field>
        </v-flex>
        <v-flex d-flex lg3 sm6 xs12>
          <v-radio-group
            :rules="valid ? [] : [v => rules.vacio(v, 'type')]"
            ref="tipo"
            :label="$t('type')"
            v-model="tournament.type"
          >
            <v-radio :label="$tc('user', 2)" value="users"></v-radio>
            <v-radio :label="$tc('team', 2)" value="teams"></v-radio>
            <v-radio :label="$tc('usersTeams')" value="usersTeams"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex d-flex xs12>
          <v-flex d-flex md6 xs12>
            <v-layout wrap>
              <v-flex d-flex lg6 md6 sm12 xs12>
                <v-menu
                  v-model="menu_start"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_start"
                      :label="$t('startAt')"
                      :rules="valid ? [] : [v => rules.vacio(v, 'startAt')]"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tournament.startAt"
                    @input="menu_start = false"
                    :first-day-of-week="1"
                    locale="es-ES"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex d-flex lg6 md6 sm12 xs12>
                <v-menu
                  v-model="menu_end"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fecha_end"
                      :label="$t('endAt')"
                      :rules="valid ? [] : [v => rules.vacio(v, 'endAt')]"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tournament.endAt"
                    @input="menu_end = false"
                    :first-day-of-week="1"
                    locale="es-ES"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-flex>
        <v-flex v-if="!tournament._id" xs12 text-xs-right>
          <v-btn @click="$emit('reset')" small color="warning">{{$t('reset')}}</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import rules from '../../../helpers/rules'
import { mapState } from 'vuex'
import UploadButton from 'vuetify-upload-button'
import { clipperBasic, clipperPreview } from 'vuejs-clipper'

export default {
  name: 'TabInformacion',
  mixins: [rules],
  components: {
    UploadButton,
    clipperBasic,
    clipperPreview
  },
  props: {
    tournamentExternal: {
      type: Object,
      required: true
    },
    Edit: {
      required: false,
      default: true,
      type: Boolean
    },
    valid: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      searchStadium: '',
      file: '',
      titleFile: '',
      menu_start: false,
      menu_end: false
    }
  },
  computed: {
    ...mapState({
      stadiums: state => state.stadiums.listSelectStadiums,
      allStadiums: state => state.stadiums.listStadiums,
      acts: state => state.acts.listSelect,
      authUser: state => state.authentication.user
    }),
    listStadiums() {
      let listStadiums = this.stadiums
      let isTrainer = !this.isAdmin && this.hasRole('teams')
      if (isTrainer) {
        listStadiums = listStadiums.filter(
          stadium =>
            this.authUser &&
            this.authUser.entities &&
            this.authUser.entities.some(entity =>
              entity.stadiumId.includes(stadium.value)
            )
        )
      }
      return listStadiums
    },
    tournament: {
      get() {
        return this.tournamentExternal
      },
      set(value) {
        this.$emit('update:tournamentExternal', value)
      }
    },
    titleButton() {
      return this.image
        ? this.$t('change', { field: this.$t('image') })
        : this.$t('upload', { field: this.$t('image') })
    },
    aulas() {
      if (
        !this.tournament.stadiumId ||
        this.tournament.stadiumId.length === 0
      ) {
        return this.valid
          ? []
          : [this.$t('error.required', { field: this.$tc('stadium') })]
      }
      let response = []
      this.tournament.stadiumId.forEach(item => {
        let temporalStadium = this.allStadiums.find(
          element => element._id === item
        )
        if (temporalStadium) {
          if (temporalStadium.pitches.length === 0) {
            response.push(
              this.$t('error.emptyStadium', { field: temporalStadium.name })
            )
          }
        }
      })
      return response
    },
    fecha_start() {
      if (!this.tournament.startAt) {
        return ''
      }
      return this.dateTransform(this.tournament.startAt)
    },
    fecha_end() {
      if (!this.tournament.endAt) {
        return ''
      }
      return this.dateTransform(this.tournament.endAt)
    },
    nameParticipants() {
      if (this.tournament.type === 'users') return this.$tc('user', 2)
      else if (this.tournament.type === 'teams') return this.$tc('team', 2)
      else return this.$t('participants')
    }
  },
  methods: {
    fileChanged(file) {
      if (file.size < 1) return
      this.createImage(file)
    },
    createImage(file) {
      this.file = file
      this.tournament.img = file
      this.titleFile = file.name
      const image = new Image()
      const reader = new FileReader()
      const vm = this

      reader.onload = e => {
        vm.tournament.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    dateTransform(date) {
      if (!date) {
        return ''
      }
      let [year, month, day] = date.split('-')
      return `${day} / ${month} / ${year}`
    }
  }
}
</script>
